// removed by extract-text-webpack-plugin
module.exports = {"widget":"_23jbENTBifucyHnrw81mpI","title":"_397G0mJCOll0mDwFNFwJcL","content":"_51IplxU1LKdxi64hhozs7","chart":"_1b1YIYnm25VP8eO_BciTYG"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets/BoxTimingChart/widget.scss
// module id = 1229
// module chunks = 0